import { render, staticRenderFns } from "./periode.vue?vue&type=template&id=640ead96&"
import script from "./periode.vue?vue&type=script&lang=js&"
export * from "./periode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports